function getState(value) {
    if (value)
        return JSON.parse(value);
}
function createStore(store, options) {
    const { storage, encrypt, decrypt } = options;
    const session = storage.getItem(store.$id);
    if (session) {
        const state = getState(decrypt ? decrypt(session) : session);
        if (state)
            store.$state = state;
    }
    else {
        const json = JSON.stringify(store.$state);
        storage.setItem(store.$id, encrypt ? encrypt(json) : json);
    }
    store.$subscribe((mutation, state) => {
        const json = JSON.stringify(state);
        storage.setItem(store.$id, encrypt ? encrypt(json) : json);
    });
}
function storePlugin(options) {
    return (context) => {
        const _options = options || {};
        const { store } = context;
        const { stores, encrypt, decrypt } = _options;
        if (stores && stores.length > 0) {
            stores.forEach((storeKey) => {
                if (typeof storeKey === 'string') {
                    if (storeKey === store.$id) {
                        const storage = _options.storage || localStorage;
                        createStore(store, { stores, storage, encrypt, decrypt });
                    }
                }
                else if (storeKey && storeKey.name === store.$id) {
                    createStore(store, {
                        stores,
                        storage: storeKey.storage,
                        encrypt,
                        decrypt,
                    });
                }
            });
        }
    };
}

export { storePlugin };
